export class UIError {
  DisplayName: string;
  UIErrorCode: string;
  UIErrorMessage: string;
  UIErrorScope: string;
  UIErrorUserAgent: string;
  ObjectType: string;

  constructor(name: string, code: string, message: string, scope: string) {
    this.DisplayName = name;
    this.UIErrorCode = code;
    this.UIErrorMessage = message;
    this.UIErrorScope = scope;
    this.ObjectType = 'UIError';
    this.UIErrorUserAgent = 'Unknown';
  }
}
